export default __webpack_public_path__ + "static/media/dercam_input_template_single_node_v59.18f85718.xlsx";